import React from 'react';
import axios from 'axios';
import { Formik } from 'formik';
import { useNavigate } from 'react-router-dom';

export default function Create() {
    const navigate = useNavigate();

    const handleSubmit = (values) => {

    }


    return (
        <React.Fragment>
            <main>

                <h1>Create Role</h1>
                <section>
                    <article>
                        <Formik
                            initialValues={{ role: '' }}
                            onSubmit={(values, { setSubmitting }) => {
                                axios.post('http://localhost:5000/Roles/CreateRole', { name: values.role })
                                    .then((response) => {
                                        if (response.status === 200) {
                                            navigate('/Admin/Roles');
                                        }
                                    })
                                    .catch((error) => {
                                        console.log(error);
                                    })
                            }}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="formContainer">
                                        <label htmlFor="name">Role Name:</label>
                                        <input type="text" id="role" name="role" onChange={handleChange} onBlur={handleBlur} values={values.role} />
                                    </div>
                                    <button type="submit">Submit</button>
                                </form>
                            )}
                        </Formik>
                    </article>
                </section>
            </main>

        </React.Fragment>
    )
}